import { render } from "./OrderOfServiceDropdown.vue?vue&type=template&id=473f52da&scoped=true"
import script from "./OrderOfServiceDropdown.vue?vue&type=script&lang=js"
export * from "./OrderOfServiceDropdown.vue?vue&type=script&lang=js"

import "./OrderOfServiceDropdown.vue?vue&type=style&index=0&id=473f52da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473f52da"]])

export default __exports__